import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3989ec30&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3989ec30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3989ec30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3989ec30')) {
      api.createRecord('3989ec30', component.options)
    } else {
      api.reload('3989ec30', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3989ec30&scoped=true&", function () {
      api.rerender('3989ec30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/currency/amonnt/index.vue"
export default component.exports